module.exports = __webpack_public_path__ + "static/example_carousel-50ac0bc6f5c866cf676b62002588774c.png";